// extracted by mini-css-extract-plugin
module.exports = {"rotator":"AboutRotator_rotator__7NNP4","rotatorContainer__item":"AboutRotator_rotatorContainer__item__wTtrz","icon":"AboutRotator_icon__OmvZd"};